import { InjectionToken } from '@angular/core';
import { SpaClientConfigBase } from '@oa/shared-core';

/** Customer-app settings loaded from GET {apiUrl}config/spa/customer before bootstrap (see main.ts). */
export type CustomerClientConfig = SpaClientConfigBase;

export const CLIENT_CONFIG = new InjectionToken<CustomerClientConfig>('CLIENT_CONFIG');
